import { ofType, combineEpics, createEpicMiddleware } from "redux-observable";
import { pipe, map, flatMap } from "rxjs/operators";
import { ajax } from "rxjs/ajax";

import {
DO_SEND_PIN, sendPinSuccess,
DO_SUBMIT_PIN, submitPinSuccess,
DO_SUBMIT_PIN_SUCCESS,DO_SUBMIT_PIN_FAIL,
DO_SEND_PIN_SUCCESS
} from './mbox-and-pin-actions'

import {RequestStatus} from 'dcx/app/util/RequestConstants';

export const sendPinEpic = action$ =>
  action$.pipe(
    ofType(DO_SEND_PIN),
    flatMap((e) => sendPin(e.data)),
    map((e) => sendPinSuccess(e))
  );

export const submitPinEpic = action$ =>
  action$.pipe(
    ofType(DO_SUBMIT_PIN),
    flatMap((e) => submitPin(e.data)),
    map((e) => submitPinSuccess(e))
  );

export const sendPin = (message) => {
  let url = `/authentication-api/send-pin`;
  return ajax({
      url: url,
      method: "POST",
      body: message
    }).pipe(map(data => data.response));
}

export const submitPin = (message) => {
  let url = `/authentication-api/submit-pin`;
  return ajax({
      url: url,
      method: "POST",
      body: message
    }).pipe(map(data => data.response));
}

let messageCount = 0;
export const mboxAndPinReducer = (state = {submitPinStatus: RequestStatus.NONE}, action) => {
  messageCount++
  switch (action.type) {
    case DO_SUBMIT_PIN:
          return {...state, submitPinStatus: RequestStatus.ACTIVE};
    case DO_SUBMIT_PIN_SUCCESS:
          const authToken = action.e.token
          return {...state, authToken, submitPinStatus: RequestStatus.SUCCESS};
    case DO_SUBMIT_PIN_FAIL:
          return {...state, submitPinStatus: RequestStatus.FAIL};
    default:
      return state;
  }
}
